import { state } from 'cerebral'
import { indexBy, prop } from 'ramda'

export const appointmentsByProfile = (get) => {
  const entities = get(state`appointments.entities`) || {}
  return indexBy(prop('profile'), Object.values(entities))
}
